module.exports = __webpack_public_path__ + "img/p1.67fc4acd.jpg";